import React from 'react';

import '../../App.scss';
import AuthorizedPage from '../../component/AuthorizedPage';
import DashboardApi from '../../api/DashboardApi';
import { Role } from '../../domain/Role';


const barState = {
    dataBar: {
      labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
      datasets: [
        {
          label: "% of Votes",
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            "rgba(255, 134,159,0.4)",
            "rgba(98,  182, 239,0.4)",
            "rgba(255, 218, 128,0.4)",
            "rgba(113, 205, 205,0.4)",
            "rgba(170, 128, 252,0.4)",
            "rgba(255, 177, 101,0.4)"
          ],
          borderWidth: 2,
          borderColor: [
            "rgba(255, 134, 159, 1)",
            "rgba(98,  182, 239, 1)",
            "rgba(255, 218, 128, 1)",
            "rgba(113, 205, 205, 1)",
            "rgba(170, 128, 252, 1)",
            "rgba(255, 177, 101, 1)"
          ]
        }
      ]
    },
    barChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            barPercentage: 1,
            gridLines: {
              display: true,
              color: "rgba(0, 0, 0, 0.1)"
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true,
              color: "rgba(0, 0, 0, 0.1)"
            },
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  }

class Dashboard extends React.Component<any,any> {

constructor(props: any) {
    super(props);
    this.state= barState;
    // Don't call this.setState() here!
  }

componentDidMount() {
//      this.loadDashboards();
  }

  async loadDashboards(){
    let response = await DashboardApi.userCount();
    if(response.success) {
        this.updateState("userCount",response.data);
    }

    response = await DashboardApi.buyerCount();
    if(response.success) {
        this.updateState("buyerCount",response.data);
    }

    response = await DashboardApi.warehouseCount();
    if(response.success) {
        this.updateState("warehouseCount",response.data);
    }
    response = await DashboardApi.listingProductCount();
    if(response.success) {
        this.updateState("listingProductCount",response.data);
    }
    response = await DashboardApi.productItemCount();
    if(response.success) {
        this.updateState("productItemCount",response.data);
    }
    response = await DashboardApi.orderCount();
    if(response.success) {
        this.updateState("orderCount",response.data);
    }
    response = await DashboardApi.basketCount();
    if(response.success) {
        this.updateState("basketCount",response.data);
    }
  }

    updateState(attr:any, value:any) {
        var currentState = this.state;
         var newState = Object.assign(currentState);
         newState[attr] = value;
         this.setState(newState);
      }


render() {
      return (
        <AuthorizedPage role={Role.BACKOFFICE_ADMIN}>
          <div className="login-pane centered-80-percent colorize-borders">
              <p>Hoş geldiniz!</p>
          </div>
        </AuthorizedPage>
      );
  }
}

export default Dashboard;
